import React, { useState } from "react";
import {
  Edit,
  EditProps,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  required,
  ImageInput,
  ImageField,
  SelectInput,
} from "react-admin";
import { makeStyles } from "@material-ui/core";
import { useTranslate } from "react-admin";
import UploadImages from '../products/UploadImages';

const useStyles = makeStyles((theme) => ({
  description: {
    width: 544,
  },
}));

const BannerTitle = (props: any) => {
  const { record } = props;
  const translate = useTranslate();
  return record ? (
    <span>{translate("resources.banners.name", { smart_count: 1 })}</span>
  ) : null;
};

const locationsList = [
  { name: "Home page", id: "home" },
  { name: "Products page", id: "product" },
  { name: "Influencers page", id: "influencer" },
  { name: "Cooking Classes page", id: "cooking" },
];

const BannerEdit = (props: EditProps) => {
  const classes = useStyles();
  const [imgId, setImgId] = useState("1");
  const [locationType, setLocationType] = useState("home");
  return (
    <Edit title={<BannerTitle />} {...props}>
      <SimpleForm>
        <UploadImages sourceName="featured_image" multiple={false} />
        <TextInput autoFocus source="name_en" label="Name English"/>
        <TextInput autoFocus source="name_ar" label="Name Arabic"/>
        <NumberInput  source="order_no" />
        <BooleanInput source="active" />  
      </SimpleForm>
    </Edit>
  );
};

export default BannerEdit;
